// contact-api.service.ts

import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom} from 'rxjs';

import type {
  ContactSubmissionPayload,
  ContactSubmissionResult,
  DemoSubmissionPayload,
  Product,
  ProductsResponse,
} from '../models/contact-page.model';
import {environment} from '../../../../../environments/environment';


@Injectable()
export class ContactApiService {
  private readonly http = inject(HttpClient);

  async submitMessage(
    payload: ContactSubmissionPayload,
  ): Promise<ContactSubmissionResult> {
    return firstValueFrom(
      this.http.post<ContactSubmissionResult>(
        `${environment.baseUrl}/consultations`,
        payload,
      ),
    );
  }

  async getProducts(): Promise<Product[]> {
    const response = await firstValueFrom(
      this.http.get<ProductsResponse>(
        `https://api.nextecontech.ai/api/v1/products`,
      ),
    );

    return response.data ?? [];
  }

  async submitDemo(
    payload: DemoSubmissionPayload,
  ): Promise<ContactSubmissionResult> {
    return firstValueFrom(
      this.http.post<ContactSubmissionResult>(
        environment.baseUrl + '/demo-requests',
        payload,
      ),
    );
  }
}
